export const resourcesCategories = [
	'Administrative',
	'Beauty and wellness',
	'Biology',
	'Business Administration',
	'Earth Sciences',
	'Education',
	'Health Sciences',
	'Humanities and Social Sciences',
	'Legal Education',
	'Medicine',
	'Multidisciplinary',
	'Religion',
	'Technology',
	'Technology - Engineering',
	'Trades',
];
